require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-jennersdorf.json") })
        }
      }, "path---betreuungseinrichtungen-jennersdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-jennersdorf!./.cache/json/betreuungseinrichtungen-jennersdorf.json
// module id = 909
// module chunks = 231608221292675